import { PropTypes, css, styled, reduxConnect } from '../lib/imports';

const baseStyles = ({ theme, showHeader }) => css`
  width: 100%;
  margin-top: ${(showHeader && theme.component.headerSize) || 0};
`;

const Wrapper = styled('main')(baseStyles);

Wrapper.propTypes = {
  children: PropTypes.node,
};

const mapStateToProps = (state) => {
  const { ui } = state;
  const { showHeader } = ui;

  return {
    showHeader,
  };
};

export default reduxConnect(mapStateToProps)(Wrapper);
